import { ReactElement, useEffect, useRef } from 'react';

import { COLOR_TOKENS } from '@backrs_ui/common-ui/dist';
import { lottieAnimations } from '@backrs_ui/common-ui/dist/assets/lottieAnimations';

import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import Lottie from 'lottie-react';
import { usePostHog } from 'posthog-js/react';

import { useBootstrap } from '../hooks/useBootstrap';
import { useAppSelector } from '../redux/hooks';

type AuthShellProps = Readonly<{
  children: ReactElement;
}>;

export const AuthShell = ({ children }: AuthShellProps) => {
  const { isBootstrapped } = useBootstrap();
  const postHog = usePostHog();
  const analyticsEnabled = process.env.REACT_APP_ANALYTICS_ENABLED === 'true';
  const user = useAppSelector((state) => state.user.user);
  const previousUserIdRef = useRef<string | number | null | undefined>(null);

  useEffect(() => {
    if (analyticsEnabled) {
      if (user?.id) {
        postHog.identify(user.id.toString(), { backrs_id: user.id.toString() });
      } else if (previousUserIdRef.current) {
        postHog.reset();
      }
    }

    previousUserIdRef.current = user?.id;
  }, [user?.id, postHog, analyticsEnabled]);

  if (!isBootstrapped) {
    return (
      <Box sx={loadingSpinnerStyle}>
        <Lottie animationData={lottieAnimations.dotsDotting} loop />
      </Box>
    );
  }

  return children;
};

const loadingSpinnerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100dvh',
  backgroundColor: COLOR_TOKENS['Beige/25'],
};
